<div class="flex flex-col">
  <div class="relative">
    <div #scrollable class="flex flex-row overflow-x-scroll snap-x snap-mandatory rounded-2xl gap-12" style="scrollbar-width: none;">
      @for(event of events(); track event.uniqueId; let i = $index; let first = $first; let last= $last) {
        <div class="snap-start min-w-full">
          <app-big-event-card [event]="event" [shouldLoadEagerly]="first"></app-big-event-card>
        </div>
      }
    </div>

    <div class="z-10 absolute right-4 top-4">
      <app-left-right-button-pair
        [mode]="buttonMode()"
        (leftPressed)="onScrollLeft()"
        (rightPressed)="onScrollRight()"
      ></app-left-right-button-pair>
    </div>
  </div>

  <div class="h-1.5"></div>

  <app-scroll-indicator
    [theme]="'dark&white'"
    [stepCount]="scrollSteps()"
    [progress]="scrollPercentage()">
  </app-scroll-indicator>
</div>
